import { useEffect } from 'react';
import { handleGlobalSearchShortcut } from './globalSearchShortcut.js';

/**
 * Registers Ctrl/Cmd+K while mounted. Renders nothing (stays mounted when modal is closed).
 *
 * @param {object} props
 * @param {boolean} props.isOpen
 * @param {() => void} [props.onOpen]
 * @param {() => void} [props.onClose]
 */
const GlobalSearchShortcutListener = ({ isOpen, onOpen, onClose }) => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      handleGlobalSearchShortcut(event, isOpen, { onOpen, onClose });
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onOpen, onClose]);

  return null;
};

export default GlobalSearchShortcutListener;
